import { yearsOfExperience } from '@seek/ca-myprofile-utils';
import gql from 'graphql-tag';

export const getYearsOfExperience = gql`
  query GetYearsOfExperience($languageCode: LanguageCodeIso) {
    viewer {
      _id
      yearsOfExperience(languageCode: $languageCode) {
        ...yearsOfExperience
      }
    }
  }
  ${yearsOfExperience}
`;

export const updateYearsOfExperience = gql`
  mutation UpdateYearsOfExperience(
    $id: ID
    $newToWorkforce: Boolean!
    $languageCode: LanguageCodeIso
  ) {
    updateYearsOfExperience(
      input: { id: $id, newToWorkforce: $newToWorkforce }
    ) {
      viewer {
        _id
        yearsOfExperience(languageCode: $languageCode) {
          ...yearsOfExperience
        }
      }
    }
  }
  ${yearsOfExperience}
`;
